import { render, staticRenderFns } from "./RoundedUserAvatar.vue?vue&type=template&id=504c6475&"
import script from "./RoundedUserAvatar.vue?vue&type=script&setup=true&lang=js&"
export * from "./RoundedUserAvatar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports